module.exports = __webpack_public_path__ + "img/pvc_900g_b1_farbauswahl_blau_lichtgrau_weiss.5a2959e9.jpg";